import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SgSelectOption } from '../../../models';

@Component({
  selector: 'sg-dropdown-chips-list',
  templateUrl: './sg-dropdown-chips-list.component.html',
  styleUrls: ['./sg-dropdown-chips-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgDropdownChipsListComponent {
  @Input() values: SgSelectOption[] = [];
  @Input() totalOptions = 0;

  @Output() deselectOptions = new EventEmitter<SgSelectOption[]>();

  get isAllSelected(): boolean {
    return this.totalOptions > 0 && this.values.length === this.totalOptions;
  }

  removeAllOptionsExceptLast(): void {
    const optionsToRemove = this.values.slice(0, this.values.length - 1);
    this.deselectOptions.emit(optionsToRemove);
  }

  removeAllOptions(): void {
    this.deselectOptions.emit(this.values);
  }
}
